export default __webpack_public_path__ + "static/media/goshen96.24643594.jpg";